import Cross from '@/assets/icons/Cross.svg';
import { HeaderLinks } from '@/utils/constants';
import { scrollWithOffset } from '@/utils/helpers';
import CustomLink from 'components/CustomLink';
import NewButton from 'components/NewButton';
import Hamburger from 'hamburger-react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';

function Header() {
  const router = useRouter();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isActive = (href: any) => router.pathname === href;

  function scrollToComponents() {
    scrollWithOffset('components', 60);
  }

  function scrollToDemo() {
    scrollWithOffset('demo', 60);
  }

  return (
    <>
      <div className="fixed z-20 w-full flex justify-between items-center bg-white px-[20px] lg:px-[100px] py-5">
        <div className="flex justify-center items-center">
          <Link href="/">
            <Image
              src={require('assets/logo/cet_g.svg')}
              alt="CET Logo"
              height={60}
              width={97}
              className="w-[97.21px] h-[60px] hover:scale-110 transition duration-200"
              priority
            />
          </Link>
        </div>

        <div className="hidden lg:flex items-center gap-10">
          {HeaderLinks.map((link, index) => (
            <CustomLink key={index} href={link.link}>
              {link.title}
            </CustomLink>
          ))}
        </div>

        <div className="lg:hidden">
          <Hamburger
            direction="right"
            size={30}
            color="#079992"
            toggled={isMenuOpen}
            toggle={setIsMenuOpen}
          />
        </div>

        <div className="hidden lg:block">
          <Link href="/user/login">
            <NewButton
              color="orange"
              className="uppercase px-12 py-[14px] rounded-lg text-base font-semibold"
            >
              Login
            </NewButton>
          </Link>
        </div>
      </div>
      <div
        className={`fixed inset-0 z-20 bg-white transition-transform duration-200 ${
          isMenuOpen ? 'translate-y-0' : '-translate-y-full'
        } shadow-lg`}
      >
        <div className="flex justify-between items-center p-5">
          <Link href="/" onClick={() => setIsMenuOpen(false)}>
            <Image
              src={require('assets/logo/cet_g.svg')}
              alt="CET Logo"
              height={60}
              width={97}
              className="w-[97.21px] h-[60px]"
            />
          </Link>
          <button onClick={() => setIsMenuOpen(false)}>
            <Image
              src={Cross}
              alt="Cross Icon"
              height={28}
              width={28}
              className="w-[28px] h-[28px]"
            />
          </button>
        </div>
        <div className="w-full flex flex-col gap-[10px] text-center">
          {HeaderLinks.map((link, index) => (
            <Link
              key={index}
              href={link.link}
              className={`${
                isActive(link.link) ? 'bg-primary text-white' : 'text-[#666666]'
              } w-full font-semibold py-[14px] hover:bg-primary hover:text-white`}
              onClick={() => setIsMenuOpen(false)}
            >
              {link.title}
            </Link>
          ))}
        </div>
        <div className="w-full px-10 mt-10">
          <Link href="/user/login" onClick={() => setIsMenuOpen(false)}>
            <NewButton
              color="orange"
              className="uppercase w-full py-[14px] text-center rounded-lg font-semibold"
            >
              Login
            </NewButton>
          </Link>
        </div>
      </div>
    </>
  );
}

export default Header;
